// baseConfigName.ts
var baseConfigName = "";
export {
  baseConfigName
};
